import {Built} from "./built";
import {WorksDone} from "./worksDone";
import {AtticAmenagment} from "./atticAmenagment";

export class Survey {
    constructor(
        public readonly built: Built,
        public readonly worksDone: WorksDone[],
        public readonly atticAmenagment: AtticAmenagment) {

    }

}